import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { CoreData } from '../core-data';

@Injectable()
export class RoleGuard {
    constructor(
        private router: Router,
        private coreData: CoreData) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        if (!this.coreData.IsLoggedIn) {
            return this.router.createUrlTree([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthenticated }]);
        }

        const url = route.url[0] === undefined ? ENavigationRoute.InterventionList : route.url[0].path;
        return (this.coreData.IsLoggedIn && this.hasPermission(url))
            || this.router.createUrlTree([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthorized }]);
    }

    hasPermission(url: string) {
        if (!this.coreData.RoleAndPermissions)
            return false;
        switch (url) {
            case ENavigationRoute.InterventionList:
                if (this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeIBMRSamples') ||
                    this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeIMLSamples') ||
                    this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeMGCESamples') ||
                    this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeMPCESamples') ||
                    this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeEauSamples') ||
                    this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeIBDSamples') ||
                    this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeIBDLacSamples') ||
                    this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeIBGNSamples')) {
                    return true;
                }
                break;
            case ENavigationRoute.Documents:
            case ENavigationRoute.Exports:
            case ENavigationRoute.Logistique:
            case ENavigationRoute.SamplingPointMap:
                return true;
            case ENavigationRoute.Metrologie:
                if (this.coreData.RoleAndPermissions.find(x => x.Name === 'CanManageSonde')) {
                    return true;
                }
                break;
            case ENavigationRoute.AnalyseList:
                if (this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanPrepareDiatomees') ||
                    this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanPrepareMacroinvertebres') ||
                    this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanAnalyseInvertebres') ||
                    this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanAnalysePhytoplancton') ||
                    this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanAnalyseDiatomees') ||
                    this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanAnalyseIBMR'))
                    return true;
                break;
        }
        return false;
    }

}